import { MARQUEE_ITEMS } from "../data/site";

export function Marquee() {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="relative border-y border-[#D4AF37]/12 bg-[#0D0D0D] py-5 overflow-hidden" data-testid="editorial-marquee">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif-lux text-lg sm:text-xl tracking-[0.3em] text-[#71717A] px-8">{item}</span>
            <span className="text-[#D4AF37]/50 text-xs">&#10022;</span>
          </span>
        ))}
      </div>
    </div>
  );
}
